import { render } from "./ModalCadastro.vue?vue&type=template&id=ddffe014&scoped=true"
import script from "./ModalCadastro.vue?vue&type=script&lang=js"
export * from "./ModalCadastro.vue?vue&type=script&lang=js"

import "./ModalCadastro.vue?vue&type=style&index=0&id=ddffe014&scoped=true&lang=css"

import exportComponent from "C:\\Users\\vinicius.martins\\Desktop\\pasta\\teste\\projeto-automacao\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddffe014"]])

export default __exports__